// icons.js

// Import all the icons you need
import DashboardIcon from '@mui/icons-material/Dashboard';
import VisibilityIcon from '@mui/icons-material/Visibility';
import GpsFixedIcon from '@mui/icons-material/GpsFixed';
import TimelineIcon from '@mui/icons-material/Timeline';
import DirectionsBusIcon from '@mui/icons-material/DirectionsBus';
import PersonIcon from '@mui/icons-material/Person';
import PeopleAltIcon from '@mui/icons-material/PeopleAlt';
import CommuteIcon from '@mui/icons-material/Commute';
import BusinessIcon from '@mui/icons-material/Business';
import GavelIcon from '@mui/icons-material/Gavel';
import GroupIcon from '@mui/icons-material/Group';
import EqualizerIcon from '@mui/icons-material/Equalizer';
import VpnKeyIcon from '@mui/icons-material/VpnKey';
import SupervisorAccountIcon from '@mui/icons-material/SupervisorAccount';
import DomainIcon from '@mui/icons-material/Domain';
import LocationCityIcon from '@mui/icons-material/LocationCity';
import AccessibilityIcon from '@mui/icons-material/Accessibility';
import EventIcon from '@mui/icons-material/Event';
import PeopleIcon from '@mui/icons-material/People';
import EventNoteIcon from '@mui/icons-material/EventNote';
import FavoriteIcon from '@mui/icons-material/Favorite';
import AttachMoneyIcon from '@mui/icons-material/AttachMoney';
import ReportProblemIcon from '@mui/icons-material/ReportProblem';
import StarIcon from '@mui/icons-material/Star';
import SettingsIcon from '@mui/icons-material/Settings';
import SchoolIcon from '@mui/icons-material/School';
import AccountBalanceIcon from '@mui/icons-material/AccountBalance';
import AssignmentIcon from '@mui/icons-material/Assignment';
import AssignmentTurnedInIcon from '@mui/icons-material/AssignmentTurnedIn';
import RoomIcon from '@mui/icons-material/Room';
import ScheduleIcon from '@mui/icons-material/Schedule';
import DirectionsCarIcon from '@mui/icons-material/DirectionsCar';

// Continue importing any other icons you use

// Map your icons to resource names
export const menuItems = [
  { name: 'dashboard', icon: <DashboardIcon /> },
  { name: 'Trips_Monitoring', icon: <VisibilityIcon /> },
  { name: 'GPS_Tracking', icon: <GpsFixedIcon /> },
  { name: 'Route_Optimization', icon: <TimelineIcon /> },
  { name: 'transportation_routes', icon: <DirectionsBusIcon /> },
  { name: 'transportation_routes_rounds', icon: <TimelineIcon /> },
  { name: 'schools', icon: <SchoolIcon /> },
  { name: 'school_sections', icon: <AccountBalanceIcon /> },
  { name: 'parents', icon: <PeopleAltIcon /> },
  { name: 'students', icon: <PersonIcon /> },
  { name: 'planner_jobs', icon: <AssignmentIcon /> },
  { name: 'planner_jobs_rounds', icon: <TimelineIcon /> },
  { name: 'planner_jobs_rounds_steps', icon: <TimelineIcon /> },
  { name: 'service_request', icon: <AssignmentTurnedInIcon /> },
  { name: 'update_location_request', icon: <RoomIcon /> },
  { name: 'DataImport', icon: <ScheduleIcon /> },
  { name: 'vehicles', icon: <DirectionsBusIcon /> },
  { name: 'couriers', icon: <PersonIcon /> },
  { name: 'additional_trips', icon: <CommuteIcon /> },
  { name: 'domains_contractors', icon: <BusinessIcon /> },
  { name: 'domains_contracts', icon: <GavelIcon /> },
  { name: 'rider_groups', icon: <GroupIcon /> },
  { name: 'planner_transportation_routes', icon: <DirectionsBusIcon /> },
  { name: 'Reports', icon: <EqualizerIcon /> },
  { name: 'user', icon: <PersonIcon /> },
  { name: 'users', icon: <PeopleAltIcon /> },
  { name: 'role', icon: <SupervisorAccountIcon /> },
  { name: 'acls_modules', icon: <VpnKeyIcon /> },
  { name: 'user_role', icon: <SupervisorAccountIcon /> },
  { name: 'organizations', icon: <DomainIcon /> },
  { name: 'businesses', icon: <BusinessIcon /> },
  { name: 'domains_regions', icon: <LocationCityIcon /> },
  { name: 'domains_education_administrations', icon: <AccountBalanceIcon /> },
  { name: 'domains_education_offices', icon: <BusinessIcon /> },
  { name: 'domains_cities', icon: <LocationCityIcon /> },
  { name: 'domains_districts', icon: <LocationCityIcon /> },
  { name: 'domains_education_levels', icon: <SchoolIcon /> },
  { name: 'domains_education_types', icon: <SchoolIcon /> },
  { name: 'domains_genders', icon: <AccessibilityIcon /> },
  { name: 'domains_grades', icon: <SchoolIcon /> },
  { name: 'domains_months', icon: <EventIcon /> },
  { name: 'domains_relative_relations', icon: <PeopleIcon /> },
  { name: 'domains_trip_shifts', icon: <ScheduleIcon /> },
  { name: 'domains_trip_types', icon: <CommuteIcon /> },
  { name: 'domains_vehicle_seats', icon: <DirectionsCarIcon /> },
  { name: 'domains_vehicle_types', icon: <DirectionsCarIcon /> },
  { name: 'domains_week_days', icon: <EventNoteIcon /> },
  { name: 'domains_health_statuses', icon: <FavoriteIcon /> },
  { name: 'domains_penalties_calculations', icon: <AttachMoneyIcon /> },
  { name: 'service_violences', icon: <ReportProblemIcon /> },
  { name: 'Transportation', icon: <CommuteIcon /> },
  { name: 'Fleet', icon: <DirectionsBusIcon /> },
  { name: 'Settings', icon: <SettingsIcon /> },
  { name: 'ServiceEvaluations', icon: <StarIcon /> },
  // Add any other menu items as needed
];

// Create the iconsNew mapping
export const iconsNew = menuItems.reduce((acc, item) => {
  acc[item.name] = item.icon;
  return acc;
}, {});
